
class QsysNamedControl {

    static validateObjectAddress(value) {
    }

    static validateMuteAddress(value) {
    }

    static suggestObjectAddress() {
    }

    static suggestMuteAddress() {
    }

    static testFormat(address) {
    }

    static validateSourceSelectorAddress(value) {
    }
}

QsysNamedControl.props = {
    muteAddress: true
}

export default QsysNamedControl;